import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { Error404Component } from "./pages/error404/error404.component";
import { Error500Component } from "./pages/error500/error500.component";
import { SharedModule } from "./shared/shared.module";
import { ServiceWorkerModule } from "@angular/service-worker";
import { TokenInterceptor } from "src/app/authentication/token.interceptor";
import { ErrorInterceptor } from "src/app/authentication/error.interceptor";
import { GlobalConstants } from "src/app/pages/common/global-variables";
import { SpecialProjectCheck } from "src/app/shared/services/common/special-project-check";
import { DataTransferService } from "src/app/shared/services/common/datatransfer.service";
import { ApiService } from "src/app/pages/common/api.service";
import { VCESCallbackComponent } from "./pages/vces-callback/vces-callback.component";
import { createErrorHandler } from "@sentry/angular";

@NgModule({
  declarations: [
    AppComponent,
    Error404Component,
    Error500Component,
    VCESCallbackComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    ServiceWorkerModule.register("ngsw-worker.js", { enabled: false }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: ErrorHandler,
      useValue: createErrorHandler({
        showDialog: false,
      }),
    },
    GlobalConstants,
    DataTransferService,
    ApiService,
    SpecialProjectCheck,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
